var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTokenTransferDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.17188V14.1719L9.16667 12.5052",
    stroke: "#717C90",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50065 14.1667L5.83398 12.5",
    stroke: "#717C90",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3327 8.33854V12.5052C18.3327 16.6719 16.666 18.3385 12.4993 18.3385H7.49935C3.33268 18.3385 1.66602 16.6719 1.66602 12.5052V7.50521C1.66602 3.33854 3.33268 1.67188 7.49935 1.67188H11.666",
    stroke: "#717C90",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3327 8.33854H14.9993C12.4993 8.33854 11.666 7.50521 11.666 5.00521V1.67188L18.3327 8.33854Z",
    stroke: "#717C90",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenTransferDark);
export default __webpack_public_path__ + "static/media/token-transfer-dark.dbf4b601474a1903cb17e24334aa7aed.svg";
export { ForwardRef as ReactComponent };